<div class="groups">
  @for(group of groups; track $index) {
    <div class="flex flex-col flex-1 gap-4 group">
      <p class="group-name">{{ 'field.group' | translate }} {{ group.name }}</p>
        <p-table
          #groupsTable
          [value]="group.teams || []"
          dataKey="id"
          [paginator]="false"
          [loading]="loading"
          stripedRows
        >
          <ng-template #header>
            <tr>
              <th pSortableColumn="name">{{ 'field.name' | translate }}</th>
            </tr>
          </ng-template>
          <ng-template #body let-team let-expanded="expanded" let-editing="editing" let-ri="rowIndex">
            <tr style="height: 75px">
              <!-- name -->
              <td>{{ team.name }}</td>
            </tr>
          </ng-template>
        </p-table>
    </div>
  }
</div>
